export const COLORS = {
    skeletonBaseColor: '#DDDDDD',
    skeletonHighlightColor: '#F3F3F3'
}